/**
 * File social-proof-carousel.js
 *
 * Handles Swiper Carousels for the homepage social proof carousel.
 */

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-unresolved */
import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener( 'DOMContentLoaded', function () {
	if ( document.querySelectorAll( '.quotes-carousel' ).length ) {
		new Swiper( '.quotes-carousel', {
			modules: [ Navigation ],
			cssMode: false,
			speed: 500,
			loop: true,
			spaceBetween: 60,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );
	}
} );
